import { defineFieldFormInterface } from "~/entities/field";
import InterfaceSelectDropdownJsonType from "./InterfaceSelectDropdownJsonType.vue";

export default defineFieldFormInterface({
  interface: "select-multiple-dropdown",
  type: "json",
  component: InterfaceSelectDropdownJsonType,
});
